<template>
    <div class="auditDetails">
        <div class="header">
            <el-avatar class="avatarImg" :size="40" src="https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png"></el-avatar>
            <div class="name">{{basicInfo.name}}</div>
        </div>
        <div class="formBox">
            <div class="title">入职人员基本信息</div>
            <el-form class="content" :model="basicInfo" label-width="120px" size="small" disabled>
                <el-form-item label="姓名">
                    <el-input v-model="basicInfo.name" class="w220"></el-input>
                </el-form-item>
                <el-form-item label="性别">
                    <el-radio-group v-model="basicInfo.sex">
                        <el-radio :label="1">男</el-radio>
                        <el-radio :label="0">女</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="出生日期">
                    <el-date-picker v-model="basicInfo.birthday" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="basicInfo.phone" class="w220"></el-input>
                </el-form-item>
                <!-- <el-form-item label="邮箱">
                    <el-input v-model="basicInfo.email" class="w220"></el-input>
                </el-form-item> -->
            </el-form>
        </div>
        <div class="formBox">
            <div class="title">人员权限分配</div>
            <el-form class="content" :model="entryForm" label-width="120px" size="small">
                <el-form-item label="企业邮箱" required>
                    <el-input v-model="entryForm.enterpriseMailbox" class="w220"></el-input>
                </el-form-item>
                <el-form-item label="入职时间" required>
                    <el-date-picker v-model="entryForm.entryTime" type="date" value-format="yyyy-MM-dd" placeholder="选择日期"></el-date-picker>
                </el-form-item>
                <el-form-item label="部门" required>
                    <div v-for="(ele,index) in entryForm.departments" :key="index">
                        <el-select v-model="ele.name" placeholder="请选择部门" size="small">
                            <el-option :value="ele.key" style="height: auto">
                                <el-tree :data="treeData" :props="defaultProps" @node-click="(data)=>chooseDepartment(data,ele)"></el-tree>
                            </el-option>
                        </el-select>
                        <img class="iconBtn" src="@/assets/img/add2.png" alt="" @click="addDepartment" v-if="index==0" />
                        <img class="iconBtn" src="@/assets/img/jian2.png" alt="" @click="delDepartment(index)" v-else />
                        <span style="color:#5E6D82;">部门负责人：</span>
                        <el-checkbox v-model="ele.isManager">是</el-checkbox>
                    </div>
                </el-form-item>
                <el-form-item label="职位" required>
                    <!-- <el-input v-model="entryForm.position" class="w220"></el-input> -->
                    <el-select v-model="entryForm.position" filterable>
                        <el-option v-for="item in positionOption" :key="item.key" :label="item.name" :value="item.name"></el-option>
                        <div class="toConfig" @click="toConfig">
                            <i class="el-icon-plus"></i>
                            <span>配置职位</span>
                        </div>
                    </el-select>
                </el-form-item>
                <el-form-item label="直属上级" required>
                    <el-select v-model="entryForm.directSuperiorUkey" placeholder="请选择">
                        <el-option v-for="item in superiorOption" :key="item.ukey" :label="item.name" :value="item.ukey">
                        </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </div>
        <div class="submitBtn">
            <el-button type="primary" size="small" @click="onSubmit(1)" :disabled="isSubmit">审批通过</el-button>
            <el-button size="small" @click="onReject(6)" :disabled="isSubmit">驳 回</el-button>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        handleSelect: {
            type: Function,
            default: null,
        },
    },
    data() {
        return {
            key: "", //入职审核key
            basicInfo: {},
            entryForm: {
                enterpriseMailbox: "",
                entryTime: "",
                departments: [{ key: "",name: "",isManager: false }],
                position: "",
                directSuperiorUkey: "",
            },
            isSubmit: false,

            //组织结构
            treeData: [],
            defaultProps: {
                children: "children",
                label: "name",
            },
            //直属上级选择下拉框
            superiorOption: [],
            //职位配置
            positionOption: [],
        };
    },
    methods: {
        // 入职人员基本信息
        getBasicInfo() {
            this.$axios.get(`${this.$personnelUrl}/EntryApplication/GetEntryApplicationDetail?key=${this.key}`).then((res) => {
                const { isSuccess, data } = res;
                if (isSuccess) {
                    this.basicInfo = data;
                }
            });
        },

        // 提交
        onSubmit(type) {
            const {enterpriseMailbox,entryTime,departments,position,directSuperiorUkey} = this.entryForm;
            if(!enterpriseMailbox){ this.$message({ message: "请填写企业邮箱" , type: 'warning'}); return false;}
            if(!entryTime){ this.$message({ message: "请选择入职时间" , type: 'warning'}); return false;}
            if(departments[0].key == ""){ this.$message({ message: "请选择部门" , type: 'warning'}); return false;}
            if(!position){ this.$message({ message: "请填写职位" , type: 'warning'}); return false;}
            if(!directSuperiorUkey){ this.$message({ message: "请选择上级" , type: 'warning'}); return false;}
            this.entryForm.departments = this.entryForm.departments.filter(ele => ele.key != "");
            let submitObj = {
                key: this.key,
                approvalStatus: type,   // 1审批通过  6驳回
                remark: "",
                enterpriseMailbox,
                entryTime,
                departments: this.entryForm.departments,
                position,
                directSuperiorUkey,
            };
            // console.log(submitObj);

            this.$axios.post(`${this.$personnelUrl}/EntryApplication/EntryAudit`, submitObj).then((res) => {
                const { isSuccess } = res;
                if (isSuccess) {
                    this.isSubmit = true;
                    if(type == 1){
                        this.$message({ message: "审批通过" , type: 'success'});
                        this.handleSelect(`/staff/staffList`);
                        this.$router.push(`/staff/staffList`);
                    }
                    if(type == 6){
                        this.$message({ message: "已驳回" , type: 'info'});
                    }
                }
            });
        },
        //驳回
        onReject(type){
            const {enterpriseMailbox,entryTime,departments,position,directSuperiorUkey} = this.entryForm;
            let submitObj = {
                key: this.key,
                approvalStatus: type,   // 1审批通过  6驳回
                remark: "",
                enterpriseMailbox,
                entryTime,
                departments: departments,
                position,
                directSuperiorUkey,
            };
            this.$axios.post(`${this.$personnelUrl}/EntryApplication/EntryAudit`, submitObj).then((res) => {
                const { isSuccess } = res;
                if (isSuccess) {
                    this.isSubmit = true;
                    this.$message({ message: "已驳回" , type: 'info'});
                }
            });
        },

        // 直属上级选择下拉框
        getUsers(){
            this.$axios.get(`${this.$personnelUrl}/EntryApplication/GetUsers`).then((res) => {
                const { isSuccess, data } = res;
                if (isSuccess) {
                    this.superiorOption = data;
                }
            });
        },
        //获取组织结构
        getTreeData(){
            this.$axios.get(`${this.$personnelUrl}/Organization/GetOrganization`).then((res) => {
                const { isSuccess, data } = res;
                if (isSuccess) {
                    this.treeData = data;
                }
            })
        },
        chooseDepartment(data,ele) {
            ele.key = data.key;
            ele.name = data.name;
        },
        addDepartment(){
            this.entryForm.departments.push({ 
                key: "",
                name: "",
                isManager: false
            })
        },
        delDepartment(index){
            this.entryForm.departments.splice(index, 1)
        },

        //获取职位配置
        getPosition(){
            this.$axios.get(`${this.$customerUrl}/v1/Config/GetPosition`).then((res) => {
                const { isSuccess, data } = res;
                if (isSuccess) {
                    this.positionOption = data;
                }
            });
        },
        toConfig(){
            let routeData = this.$router.resolve({
                path: "/settingIndex",
                query: { type: "system" },
            });
            window.open(routeData.href, "_blank");
        },

    },
    mounted() {
        this.key = this.$route.query.key;
        this.getBasicInfo();    //入职人员基本信息

        this.getUsers();        //直属上级选择下拉框
        this.getTreeData();     //获取组织结构
        this.getPosition();     //获取职位配置
    },
};
</script>

<style lang="scss" scoped>
.auditDetails {
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
    padding: 20px;
    .header {
        display: flex;
        .name {
            margin-left: 20px;
            height: 40px;
            line-height: 40px;
            font-size: 16px;
            color: #3a3a3a;
        }
    }
    .formBox {
        margin-top: 20px;
        .title {
            margin-bottom: 20px;
            line-height: 16px;
            font-size: 16px;
            font-weight: bold;
            color: #2a3f58;
            padding-left: 10px;
            border-left: 4px solid var(--themeColor);
        }
        .content {
            .w220{
                width: 220px;
            }
            .iconBtn{
                vertical-align: middle;
                cursor: pointer;
                margin-left: 20px;
                margin-right: 20px;
            }
        }
    }
    .submitBtn {
        border-top: 1px solid #e0e6ed;
        padding-top: 20px;
        padding-left: 40px;
    }
}
.toConfig{
    cursor: pointer;
    text-align: center;
    height: 32px;
    line-height: 32px;
    font-size: 14px;
    color: #6a6a6a;
    &:hover{
        background-color: #F5F7FA;
    }
}
</style>